"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var InfoCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "clip-rule": "evenodd", "d": "M23 12a11 11 0 11-22 0 11 11 0 0122 0zm-12 4a1 1 0 102 0v-4a1 1 0 10-2 0v4zm1-7a1 1 0 100-2h-.01a1 1 0 100 2H12z", "fill-rule": "evenodd" } }] }, "name": "info-circle", "theme": "filled" };
exports.default = InfoCircleFilled;
